import React from "react";

import { JollyRancherChip } from "veneer/Chip";

import osMetaMap from "cortex/ui/src/fleet/constant/osPlatform";

function formatOsBadge(osId?: string) {
  if (!osId) {
    return null;
  }
  const key = osId.toLowerCase();
  const osMeta = osMetaMap[osId] || { label: osId };
  return <JollyRancherChip color="blue" key={key} label={osMeta.label} />;
}

export { formatOsBadge };
export default { formatOsBadge };
